import React, { useState } from "react";
import { Download, Archive } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

// GDPR / App Store "your data" export: ZIP with data.json + photos + recordings.
const DataExport = () => {
  const { user } = useAuth();
  const [busy, setBusy] = useState(false);
  if (!user) return null;

  const download = async () => {
    setBusy(true);
    try {
      const r = await api.get("/account/export", { responseType: "blob", timeout: 180000 });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url; a.download = `teach-your-child-credit-export-${new Date().toISOString().slice(0, 10)}.zip`; a.click();
      setTimeout(() => URL.revokeObjectURL(url), 5000);
      toast.success("Your data is downloading", { description: `data.json plus ${r.headers["x-media-count"] ?? 0} photo/audio file${r.headers["x-media-count"] === "1" ? "" : "s"}.` });
    } catch { toast.error("Could not build the export", { description: "Please try again in a moment." }); } finally { setBusy(false); }
  };

  return (
    <section id="data-export" className="mt-10 rounded-3xl border-2 border-[#c9ecf5] bg-[#e9f9fd] p-6" data-testid="data-export-section">
      <div className="flex flex-col sm:flex-row sm:items-center gap-4">
        <span className="w-12 h-12 rounded-2xl bg-white text-[#1b8bc9] flex items-center justify-center flex-shrink-0"><Archive /></span>
        <div className="flex-1">
          <h2 className="text-lg font-bold text-[#0c4a6e]" style={{ fontFamily: "Literata, serif" }}>Download your data</h2>
          <p className="text-sm text-[#0c4a6e]/80 mt-1">A ZIP with everything your family owns: account and children as JSON, lesson progress, cheers, family links, pep talks, plus every photo and voice recording.</p>
        </div>
        <button type="button" onClick={download} disabled={busy} className="btn-pill bg-[#1b8bc9] hover:bg-[#156f9f] text-white text-sm inline-flex items-center gap-2 disabled:opacity-60" data-testid="data-export-button"><Download size={16} /> {busy ? "Packing..." : "Download ZIP"}</button>
      </div>
    </section>
  );
};

export default DataExport;
